<h2 mat-dialog-title>Confirmación</h2>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onAccept()" cdkFocusInitial>Sí</button>
    <button mat-stroked-button (click)="onCancel()">No</button>
</div>